import React from 'react';
import * as core from 'cw-ui-core';
import getDialog from './DialogFactory';
import AppContainer from 'src/components/App/AppContainer';
import LandingPageContainer from 'src/components/LandingPage/LandingPageContainer';
import SignInErrorPage from 'src/components/SignInErrorPage/SignInErrorPage';
import LoadingComponent from './components/Loading/LoadingComponent';
import { getUrl } from 'src/services/ApiService';
import { addCookieAuthToRequests } from 'src/services/AuthService';
import { getOidcConfig } from './oidcConfig';

export const MODULE_ID = 'product-insights';

const onBeforeAppLoad = configJson => {
    const apiUrl = getUrl();
    addCookieAuthToRequests(apiUrl);

    const oidcConfig = getOidcConfig(configJson, apiUrl);
    core.initializeOidc(oidcConfig);
};

const config = {
    includeOidc: true,
    onBeforeAppLoad,
    oidcLoginComponent: <LandingPageContainer />,
    oidcErrorComponent: SignInErrorPage,
    loadingComponent: <LoadingComponent alignCenter />,
    screenComponent: <AppContainer />,
    getDialog,
    configJsonPath: '/config.json',
};

core.setTheme('#0067B1');
core.appEntryPoint(MODULE_ID, config);
